<template>
    <div>
        <h1 class="mt-4 text-4xl tracking-tight font-extrabold text-white sm:mt-5 sm:leading-none lg:mt-6 lg:text-5xl xl:text-5xl" v-if="!small">
            <span class="md:block" v-for="(headline, idx) in headlines">
                <span :class="idx > 0 ? 'text-blue-500 md:block' : 'md:block'">
                    <slot name="icon" v-if="idx === 0"></slot>
                    {{headline}}
                </span>
                {{ ' ' }}
            </span>
        </h1>
        <h1 class="mt-4 text-4xl tracking-tight font-bold text-white sm:mt-5 sm:leading-none" v-if="small">
            <span class="md:block" v-for="(headline, idx) in headlines">
                <span :class="idx > 0 ? 'text-blue-500 inline-flex' : 'inline-flex'">
                    <slot name="icon" v-if="idx === 0"></slot><span>{{headline}}</span>
                </span>

                {{ ' ' }}
            </span>
        </h1>
        <p class="mt-3 text-md text-white sm:mt-5 whitespace-pre-wrap" v-if="subline" v-html="subline"></p>
    </div>
</template>
<script>

export default {
    props: {
        headlines: Array,
        subline: String,
        small: Boolean,
    }
};
</script>
